import { useLang } from '../context/LangContext';
import { MARQUEE_ITEMS } from '../i18n/translations';

export default function Marquee() {
  const { lang } = useLang();
  const items = MARQUEE_ITEMS[lang] || MARQUEE_ITEMS.en;

  // Duplicate 4× so the loop is seamless at any screen width
  const base = items.flatMap((text, i) => [
    { key: `t${i}`, sep: false, text },
    { key: `s${i}`, sep: true },
  ]);
  const all = [...base, ...base, ...base, ...base].map((x, i) => ({ ...x, key: x.key + i }));

  return (
    <div className="marquee-strip" aria-hidden="true">
      <div className="marquee-track">
        {all.map(x =>
          x.sep
            ? <span key={x.key} className="marquee-item marquee-sep">
                <img src={process.env.PUBLIC_URL + '/Flower.png'} alt="" className="marquee-flower" />
              </span>
            : <span key={x.key} className="marquee-item">{x.text}</span>
        )}
      </div>
    </div>
  );
}
